import $ from "jquery";

import header, { openSenturoModal } from "./components/header";
import reviewSlider from "./components/reviews-slider";
import video from "./components/video";
import signup from "./components/signup";
import input from "./components/input";

import { promoPopupBanner } from "./components/promo-banner";
import { googleTagManagerEnhancedEcommerce } from "./components/googleAnalytics";
import { smoothScrollToID } from "./components/smoothSroll";
import { landingPageInit } from "./components/landing-page";
import { setupReferrerCookie } from "./components/cookie";
import { initClientSaySwaper } from "./components/client-say.slider";
import { setupBusinessPricingCalculator } from "./components/business-pricing";

window.onload = () => {
  header();
  reviewSlider();
  video();
  googleTagManagerEnhancedEcommerce();
};

$(document).ready(() => {
  initClientSaySwaper();
  setupBusinessPricingCalculator();

  $(".chromebook-wrapper .close-wrapper").click(function () {
    $(".chromebook-wrapper").hide();
    localStorage.setItem("chromebook", true);
  });

  let isBannerClosed = localStorage.getItem("chromebook");
  if (!isBannerClosed) {
    $(".chromebook-wrapper").show();
  }

  $(".collapsible-faq-container").click(function () {
    $(this).toggleClass("toggled");
  });

  if ($(".monitoring-item.trust-view")) {
    $(".monitoring-item:not(.trust-view)").click(function () {
      let id = $(this).attr("id");
      if ($(window).width() > 900) {
        $(`#${id}-info`).fadeIn("fast");
      }
    });

    $($(`.additional-info .close-control`)).click(function () {
      $(this).closest(".additional-info").fadeOut("fast");
    });
  }
});

// jquery based code
signup();
input();
promoPopupBanner();
landingPageInit();
setupReferrerCookie();
openSenturoModal();

smoothScrollToID("a[href='#features']", "#features");
smoothScrollToID("a[href='#pricing']", "#pricing");
